import * as Dialog from "@radix-ui/react-dialog";
import { IconX } from "@tabler/icons-react";

interface ConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  isForChecking?: boolean;
  isCrosswordCompleted?: boolean;
}

export function ConfirmModal({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  isForChecking = false,
  isCrosswordCompleted = false,
}: ConfirmModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50" />
        <Dialog.Content className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] fixed top-1/2 left-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 rounded-lg border border-gray-200 bg-white p-6 shadow-lg duration-200">
          <div className="flex flex-col space-y-1.5 text-center sm:text-left">
            <Dialog.Title className="text-lg leading-none font-semibold tracking-tight text-gray-900">
              {isForChecking ? t("Check Answers") : t("Incomplete Crossword")}
            </Dialog.Title>
            <Dialog.Description className="text-sm text-gray-600">
              {isForChecking
                ? isCrosswordCompleted
                  ? t("Do you want to check your answers?")
                  : t(
                      "There are empty cells in the crossword. Do you want to check your current answers?",
                    )
                : isCrosswordCompleted
                  ? t("Are you sure you want to finish?")
                  : t(
                      "There are empty cells in the crossword. Are you sure you want to finish?",
                    )}
            </Dialog.Description>
          </div>

          <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={onCancel}
              className="inline-flex h-9 items-center justify-center rounded-md border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-900 transition-colors hover:bg-gray-50 focus:ring-2 focus:ring-gray-950 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
            >
              {t("Cancel")}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="inline-flex h-9 items-center justify-center rounded-md bg-[#f7b73e] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#FBAC17] focus:ring-2 focus:ring-[#f7b73e] focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
            >
              {isForChecking ? t("Check Answers") : t("Finish Anyway")}
            </button>
          </div>

          <Dialog.Close asChild>
            <button
              type="button"
              className="absolute top-4 right-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-gray-950 focus:ring-offset-2 focus:outline-none disabled:pointer-events-none"
              aria-label={t("Close")}
            >
              <IconX className="h-4 w-4" />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
